import React from 'react'
import PropTypes from 'prop-types'
import { Marker } from 'react-google-maps'
import { coordsToGoogleMapCoords } from '../Map/helpers'
import InfoBox from '../InfoBox/index'
import toggle from 'components/common/hoc/toggle'
import { DEFAULT_MARKER, assetMap } from '../Marker/constants'

const GoogleMapsInfoBoxMarker = ({
  children,
  position,
  asset = DEFAULT_MARKER,
  expanded,
  toggleHandlers
}) =>
  <Marker
    position={ coordsToGoogleMapCoords(position) }
    icon={ assetMap[asset] }
    { ...toggleHandlers }>
    {
      expanded &&
        <InfoBox onCloseClick={ () => toggleHandlers.onClick() } >
          { children }
        </InfoBox>
    }
  </Marker>

GoogleMapsInfoBoxMarker.propTypes = {
  asset: PropTypes.string,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  position: PropTypes.shape(),
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func,
    onKeyPress: PropTypes.func
  })
}

export default toggle(GoogleMapsInfoBoxMarker)
